// Utilidad de hide/show para la validacion de obligatorios.
//
// arrayHidden tiene la forma { preguntaControlId: [idsOcultos...] } (lo que
// devuelve get_hide_show_questions y arma isDisplayed en Show.jsx). Una pregunta
// esta oculta si su id aparece en cualquiera de esos arrays.
//
// Se usa en la validacion para NO exigir como obligatorias las preguntas que
// estan escondidas por una condicion (el usuario no puede verlas ni llenarlas).
export function isQuestionHidden(arrayHidden, questionId) {
  if (!arrayHidden) return false;
  return Object.values(arrayHidden).some(
    (value) => Array.isArray(value) && value.some((id) => id == questionId)
  );
}
